/* eslint-disable no-unused-vars */
import { useState, useCallback, useEffect } from 'react';

const useRerender = () => {
  const [, setState] = useState(0);
  return useCallback(() => setState((state) => state + 1), []);
};

export const useToggleState = (initalDataArr = []) => {
  const [stateSet, setStateSet] = useState(() => new Set(initalDataArr));
  const state = [...stateSet.values()];

  const rerender = useRerender();

  useEffect(() => {
    setStateSet(new Set(initalDataArr));
  }, [initalDataArr.length]);

  const isActive = useCallback((groupName) => stateSet.has(groupName), [stateSet]);

  const toggle = useCallback(
    (...stateItems) => {
      stateItems.forEach((stateItem) => {
        return isActive(stateItem) ? stateSet.delete(stateItem) : stateSet.add(stateItem);
      });
      rerender();
    },
    [isActive],
  );
  const toggleOn = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => !stateSet.has(stateItem))),
    [toggle],
  );
  const toggleOff = useCallback(
    (...stateItems) => toggle(...stateItems.filter((stateItem) => stateSet.has(stateItem))),
    [toggle],
  );
  return { state, isActive, toggle, toggleOn, toggleOff };
};
